module.exports = __webpack_public_path__ + "img/about-bg5.aa354d59.png";